// Generated by scripts/build-ui-icons.mjs.
export { UserPlus as default } from "../ui/glyphs-8";
